

export default class ContextDataSource  {

  constructor(Vue, id) {
    this._id = id
    this.$store = Vue.$store
    this.$vue = Vue

  }
  callAction() {

  }

  getData() {
    return this.$store.getters.getCurrentPageContext
  }

  refresh() {
  }

}
